import React from 'react';
import { ScreenCard } from '../../regions/ScreenCard';

interface GamePanelCardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  surface?: 'panel' | 'soft' | 'none';
  className?: string;
}

export function GamePanelCard({
  children,
  surface = 'soft',
  className = '',
  ...props
}: GamePanelCardProps) {
  const baseClassName = surface === 'panel'
    ? 'rounded-xl p-4'
    : surface === 'soft'
      ? 'rounded-xl border border-brand-border p-4 shadow-none'
      : '';

  return (
    <ScreenCard surface={surface} className={`${baseClassName} ${className}`.trim()} {...props}>
      {children}
    </ScreenCard>
  );
}
